module.exports = __webpack_public_path__ + "img/truck1.cb1eea81.svg";